export enum ECustomPageEmbeddedMessageType {
    askData = 'askData',
    sendData = 'sendData',
    save = 'save',
    closeModal = 'closeModal',
    statusChanged = 'statusChanged',
    error = 'error',
    savingDone = 'savingDone',
}
export interface ICustomPageEmbeddedPostMessage {
    message: 'cp_embedded_data';
    messageType: ECustomPageEmbeddedMessageType;
    data?: any;
}

export interface ICustomPageEmbeddedAskDataPostMessage extends ICustomPageEmbeddedPostMessage {
    messageType: ECustomPageEmbeddedMessageType.askData;
}

export interface ICustomPageEmbeddedSendDataPostMessage extends ICustomPageEmbeddedPostMessage {
    messageType: ECustomPageEmbeddedMessageType.sendData;
    data: ICustomPageEmbeddedInitialData;
}

export interface ICustomPageEmbeddedStatusChangedPostMessage extends ICustomPageEmbeddedPostMessage {
    messageType: ECustomPageEmbeddedMessageType.statusChanged;
    data: {
        canSave: boolean;
    };
}

export interface ICustomPageEmbeddedSavingDoneMessage extends ICustomPageEmbeddedPostMessage {
    messageType: ECustomPageEmbeddedMessageType.savingDone;
    data: undefined;
}

export interface ICustomPageEmbeddedInitialData {
    idExaminations: string[];
    idCustomPageRoot: string;
    researchArchive?: boolean;
    exportRequests?: ICustomPageEmbeddedExportRequestsData[];
}

export interface ICustomPageEmbeddedExportRequestsData {
    studyInstanceUID: string;
    seriesInstanceUID: string;
    sopInstanceUID: string;
    retrieveUrl: string;
    repositoryFilePath: string;
}

export const isCustomPageEmbeddedPostMessage = (data: any): data is ICustomPageEmbeddedPostMessage =>
    data?.message === 'cp_embedded_data';

export const isCustomPageEmbeddedSendDataPostMessage = (data: any): data is ICustomPageEmbeddedSendDataPostMessage =>
    isCustomPageEmbeddedPostMessage(data) && data.messageType === ECustomPageEmbeddedMessageType.sendData;
